import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { ConsultorioTelefoneDeleteRequest, ConsultorioTelefoneInsertRequest, ConsultorioTelefoneRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-telefone.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class ConsultorioTelefoneService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.consultorioPrivado.telefoneConsulta;
    readonly PATH_INSERIR = SICOM_PATHS.registro.medico.consultorioPrivado.telefone;

    buscar(params: Pessoa & { idConsultorio: number }, context?: HttpContext): Observable<ConsultorioTelefoneRequest[]> {
        const httpParams = new HttpParams().set('id', params.id).set('uf', params.uf).set('idConsultorio', params.idConsultorio);
        return this.http.get<ConsultorioTelefoneRequest[]>(this.PATH, { params: httpParams, context });
    }

    inserirTelefone(pessoa: Pessoa, body: ConsultorioTelefoneInsertRequest, context?: HttpContext): Observable<void> {
        const httpParams = new HttpParams().set('id', pessoa.id).set('uf', pessoa.uf);
        return this.http.post<void>(this.PATH_INSERIR, body, { params: httpParams, context });
    }

    deletarTelefone(pessoa: Pessoa, body: ConsultorioTelefoneDeleteRequest, context?: HttpContext): Observable<void> {
        const httpParams = new HttpParams().set('id', pessoa.id).set('uf', pessoa.uf).set('idConsultorio', body.idConsultorio).set('nuTelefone', body.nuTelefone).set('nuDdd', body.nuDdd).set('inTipoTelefone', body.inTipoTelefone);
        return this.http.delete<void>(this.PATH_INSERIR, { params: httpParams, context });
    }
}
